//==============================================================================
// メニュー開閉
//==============================================================================
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-toggle="menu"]').forEach(item => {
        item.addEventListener('click', () => {
            item.classList.toggle('active');
        });
    });
});
